import { render, staticRenderFns } from "./TransferStation.vue?vue&type=template&id=13ddfcd6&scoped=true"
import script from "./TransferStation.vue?vue&type=script&lang=ts"
export * from "./TransferStation.vue?vue&type=script&lang=ts"
import style0 from "./TransferStation.vue?vue&type=style&index=0&id=13ddfcd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ddfcd6",
  null
  
)

export default component.exports